/* redirected by alias field(s) in  */
module.exports = require('./browser.js');